import {
  withTranslation,
} from 'react-i18next';

import GeoDialogView from './GeoDialogView';

const TranslatedComponent = withTranslation()(GeoDialogView);

const Component = TranslatedComponent;

export default Component;
